import { useState } from "react";
import Button from "src/components/atoms/Button";
import { usePluginConfig } from "../../contexts/pluginContext";
import MarketingEventDialog from "../organisms/MarketingEventDialog";

const CreateEventButton = (props) => {
	const [showModalForm, setShowModalForm] = useState(false);
	const pluginConfig = usePluginConfig();
	const publisher = pluginConfig.publisherSettings.publisher;
	const eventSubmissionUrl = publisher.event_submission_url;

	const handleClick = () => {
		if (eventSubmissionUrl) {
			window.open(eventSubmissionUrl, "_blank");
		} else {
			setShowModalForm(true);
		}
	};

	return (
		<>
			<Button onClick={handleClick} {...props} text="Create an Event" />
			{showModalForm && (
				<MarketingEventDialog setShowModalForm={setShowModalForm} />
			)}
		</>
	);
};

export default CreateEventButton;
